const defaultForDev = 'http://localhost:8080/wakeel/api';
// الباكند الاحتياطي (معطّل): https://general-v1.execute-iq.com/wakeel/api
const defaultForProd = 'https://api-wakeel.execute-iq.com/wakeel/api';

/** افتراضي خدمة تذاكر FTTH (Python): GET {base}/api/agent/{resellerId}/tickets */
const defaultTicketsFetchBase = 'https://python-wakeel.execute-iq.com';

function stripTrailingSlashes(s: string): string {
  return s.replace(/\/+$/, '');
}

/** نفس أساس طلبات axios (REACT_APP_API_URL + افتراضيات التطوير/الإنتاج). */
export function getReactAppApiBaseUrl(): string {
  const trimmed = process.env.REACT_APP_API_URL?.trim();
  if (trimmed) return stripTrailingSlashes(trimmed);
  const base =
    process.env.NODE_ENV === 'development' ? defaultForDev : defaultForProd;
  return stripTrailingSlashes(base);
}

/**
 * أساس جلب التذاكر: GET {base}/api/agent/{resellerId}/tickets + Authorization: Bearer
 * الافتراضي: python-wakeel. التجاوز: REACT_APP_TICKETS_BASE_URL (مثلاً بيئة محلية).
 */
export function getTicketsFetchBaseUrl(): string {
  const explicit = process.env.REACT_APP_TICKETS_BASE_URL?.trim();
  if (explicit) return stripTrailingSlashes(explicit);
  return defaultTicketsFetchBase;
}
